import Chip from "@mui/material/Chip";

interface VisibilityChipProps {
  visible: boolean;
  visibleLabel: string;
  hiddenLabel: string;
}

/** Compact, shared visibility state for calendar and dashboard content lists. */
export function VisibilityChip({
  visible,
  visibleLabel,
  hiddenLabel,
}: VisibilityChipProps) {
  return (
    <Chip
      label={visible ? visibleLabel : hiddenLabel}
      color={visible ? "success" : "default"}
      variant="outlined"
      size="small"
    />
  );
}
